// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c_B0697kLVznW3bWekZO {
  border: none;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
  font-family:
    Roboto Condensed,
    Arial,
    Helvetica CY,
    Helvetica,
    sans-serif;
  text-align: left;
  width: 80px;
  height: 80px;
  margin: 40px auto;
  position: relative;
  display: block;
  transform: scale(1);
  animation: TF3sybAMndWY6sO8jaub 1.2s ease-in-out 0s infinite normal none
    running;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  will-change: transform;
}

.TaDaexM7wkH0jtA9n4Oh {
  animation: none;
}

.ND0CZc0YJ46p8NGD4Ifl {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  transform-style: preserve-3d;
  transition: transform 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transform: rotateX(20deg) rotateY(-20deg);
}

.pumMWBD4YmuyutIwPDS9 {
  transition: none;
}

.qDL8ppnHO_hIUBQo4CVE {
  transform: rotateX(1099deg) rotateY(1059deg);
}

.hV0lCAQr7ovCsulf5tZW {
  transform: rotateX(829deg) rotateY(1059deg);
}

.WCE_IuErKuaFS0M5ZOG_ {
  transform: rotateX(1099deg) rotateY(969deg);
}

.eUuANVZhhE5Gwg2HquSN {
  transform: rotateX(1099deg) rotateY(1149deg);
}

.VFZn8Yy4zdg9ePkQV4CB {
  transform: rotateX(1009deg) rotateY(1059deg);
}

.jpfQcCg9hbtkLYgup14H {
  transform: rotateX(1279deg) rotateY(1059deg);
}

.pgiQt81ng28Wxupb_rKw,
.NGaLMgJLIjZHIXA9l7Tg,
.wtUxIXy6V_Ikjd1j7UDI {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.wtUxIXy6V_Ikjd1j7UDI {
  background: #fff;
  box-shadow: inset 0 0 20px #ccc;
  border-radius: 10px;
}

.ZcRKQjjtd22yizSepI4o {
  transform: translateZ(40px);
}

.XYS9IllcnL6HN6_K_bOr {
  transform: rotateX(-180deg) translateZ(40px);
}

.XAq3c1qmOTCB4BPa7OQO {
  transform: rotateY(90deg) translateZ(40px);
}

.V7M8MRUdejBl_ih4kWpg {
  transform: rotateY(-90deg) translateZ(40px);
}

.PcYOCiMX3XsTpvTNs4Og {
  transform: rotateX(90deg) translateZ(40px);
}

.QHYmVYyEzrE1YGPVRIVO {
  transform: rotateX(-90deg) translateZ(40px);
}

.pgiQt81ng28Wxupb_rKw {
  background: #e0e0e0;
  box-shadow: none;
  transform: translateZ(0);
}

.eEHECNdxyfNetbb2uxhz {
  transform: rotateY(90deg);
}

.oDuusbeGcEyF9Gaw8UX2 {
  transform: rotateX(90deg);
}

.NGaLMgJLIjZHIXA9l7Tg {
  background: #e0e0e0;
  border-radius: 10px;
}

.jB0r1GA_SxACwmxz54e6 {
  transform: translateZ(38px);
}

.Wgnj2s7ahfzptk3gpxBQ {
  transform: rotateX(-180deg) translateZ(38px);
}

.HsXdGzSF73NNJcFOkOpN {
  transform: rotateY(90deg) translateZ(38px);
}

.OvE3xjWwh3qC_pGkf3qF {
  transform: rotateY(-90deg) translateZ(38px);
}

.oAgVfLZXk0IR7pPbplDD {
  transform: rotateX(90deg) translateZ(38px);
}

.fM6UhbbuAduiYXqauaOe {
  transform: rotateX(-90deg) translateZ(38px);
}

.k34ylA69xvAnTJze51RY {
  position: absolute;
  width: 22%;
  height: 22%;
  border-radius: 50%;
  background: #444;
  box-shadow: inset 5px 0 10px #000;
}

.EHQX7Pc5tKXz0Qv7yQqA {
  margin: 39% 0 0 39%;
}

.T0E1Zj7uBztCXs7tDMKN {
  margin-top: 11%;
}

.YdUNYih5T3ONxmbtszgR {
  margin-left: 67%;
}

.zHBOyu8Lsc9ZpXWUEiDj {
  margin-left: 11%;
}

.DH3FbQg1SP0Jygl9GKwo {
  margin-top: 67%;
}

.ULkUBsWsjl2ipabpjTGK,
.y7aaWWVEOJ6rLo86sXw8 {
  transition:
    opacity 0.3s ease-out,
    transform 0.3s ease-out;
}

.nCq3rlXBk5QwP7pAeOAN,
.QCC0Eh2jUB1wXKtIdrkW {
  opacity: 0;
  transform: scale(0);
}

@keyframes TF3sybAMndWY6sO8jaub {
  0%,
  50%,
  100% {
    transform: rotate(0deg);
  }
  10%,
  30% {
    transform: rotate(-10deg);
  }
  20%,
  40% {
    transform: rotate(10deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dice/Dice.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf;;;;;cAKY;EACZ,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB;WACS;EACT,wCAAwC;EACxC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qBAAqB;EACrB,4BAA4B;EAC5B,8DAA8D;EAC9D,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE;;2BAEyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,uBAAuB;EACzB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,wBAAwB;EAC1B;AACF","sourcesContent":[".dice {\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: none;\n  cursor: pointer;\n  font-family:\n    Roboto Condensed,\n    Arial,\n    Helvetica CY,\n    Helvetica,\n    sans-serif;\n  text-align: left;\n  width: 80px;\n  height: 80px;\n  margin: 40px auto;\n  position: relative;\n  display: block;\n  transform: scale(1);\n  animation: trambling-animation 1.2s ease-in-out 0s infinite normal none\n    running;\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  will-change: transform;\n}\n\n.dice__disabledAnimation {\n  animation: none;\n}\n\n.dice_box {\n  width: 80px;\n  height: 80px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: inline-block;\n  transform-style: preserve-3d;\n  transition: transform 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transform: rotateX(20deg) rotateY(-20deg);\n}\n\n.dice_box__disableTransition {\n  transition: none;\n}\n\n.dice_box__face1 {\n  transform: rotateX(1099deg) rotateY(1059deg);\n}\n\n.dice_box__face2 {\n  transform: rotateX(829deg) rotateY(1059deg);\n}\n\n.dice_box__face3 {\n  transform: rotateX(1099deg) rotateY(969deg);\n}\n\n.dice_box__face4 {\n  transform: rotateX(1099deg) rotateY(1149deg);\n}\n\n.dice_box__face5 {\n  transform: rotateX(1009deg) rotateY(1059deg);\n}\n\n.dice_box__face6 {\n  transform: rotateX(1279deg) rotateY(1059deg);\n}\n\n.dice_cover,\n.dice_inner,\n.dice_side {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.dice_side {\n  background: #fff;\n  box-shadow: inset 0 0 20px #ccc;\n  border-radius: 10px;\n}\n\n.dice_side__front {\n  transform: translateZ(40px);\n}\n\n.dice_side__back {\n  transform: rotateX(-180deg) translateZ(40px);\n}\n\n.dice_side__right {\n  transform: rotateY(90deg) translateZ(40px);\n}\n\n.dice_side__left {\n  transform: rotateY(-90deg) translateZ(40px);\n}\n\n.dice_side__top {\n  transform: rotateX(90deg) translateZ(40px);\n}\n\n.dice_side__bottom {\n  transform: rotateX(-90deg) translateZ(40px);\n}\n\n.dice_cover {\n  background: #e0e0e0;\n  box-shadow: none;\n  transform: translateZ(0);\n}\n\n.dice_cover__x {\n  transform: rotateY(90deg);\n}\n\n.dice_cover__z {\n  transform: rotateX(90deg);\n}\n\n.dice_inner {\n  background: #e0e0e0;\n  border-radius: 10px;\n}\n\n.dice_inner__front {\n  transform: translateZ(38px);\n}\n\n.dice_inner__back {\n  transform: rotateX(-180deg) translateZ(38px);\n}\n\n.dice_inner__right {\n  transform: rotateY(90deg) translateZ(38px);\n}\n\n.dice_inner__left {\n  transform: rotateY(-90deg) translateZ(38px);\n}\n\n.dice_inner__top {\n  transform: rotateX(90deg) translateZ(38px);\n}\n\n.dice_inner__bottom {\n  transform: rotateX(-90deg) translateZ(38px);\n}\n\n.dice_dot {\n  position: absolute;\n  width: 22%;\n  height: 22%;\n  border-radius: 50%;\n  background: #444;\n  box-shadow: inset 5px 0 10px #000;\n}\n\n.dice_dot__center {\n  margin: 39% 0 0 39%;\n}\n\n.dice_dot__top {\n  margin-top: 11%;\n}\n\n.dice_dot__left {\n  margin-left: 67%;\n}\n\n.dice_dot__right {\n  margin-left: 11%;\n}\n\n.dice_dot__bottom {\n  margin-top: 67%;\n}\n\n.dice__animateEnterActive,\n.dice__animateLeaveActive {\n  transition:\n    opacity 0.3s ease-out,\n    transform 0.3s ease-out;\n}\n\n.dice__animateEnter,\n.dice__animateLeaveTo {\n  opacity: 0;\n  transform: scale(0);\n}\n\n@keyframes trambling-animation {\n  0%,\n  50%,\n  100% {\n    transform: rotate(0deg);\n  }\n  10%,\n  30% {\n    transform: rotate(-10deg);\n  }\n  20%,\n  40% {\n    transform: rotate(10deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var dice = `c_B0697kLVznW3bWekZO`;
var _1 = `TF3sybAMndWY6sO8jaub`;
export { _1 as "trambling-animation" };
export var dice__disabledAnimation = `TaDaexM7wkH0jtA9n4Oh`;
export var dice_box = `ND0CZc0YJ46p8NGD4Ifl`;
export var dice_box__disableTransition = `pumMWBD4YmuyutIwPDS9`;
export var dice_box__face1 = `qDL8ppnHO_hIUBQo4CVE`;
export var dice_box__face2 = `hV0lCAQr7ovCsulf5tZW`;
export var dice_box__face3 = `WCE_IuErKuaFS0M5ZOG_`;
export var dice_box__face4 = `eUuANVZhhE5Gwg2HquSN`;
export var dice_box__face5 = `VFZn8Yy4zdg9ePkQV4CB`;
export var dice_box__face6 = `jpfQcCg9hbtkLYgup14H`;
export var dice_cover = `pgiQt81ng28Wxupb_rKw`;
export var dice_inner = `NGaLMgJLIjZHIXA9l7Tg`;
export var dice_side = `wtUxIXy6V_Ikjd1j7UDI`;
export var dice_side__front = `ZcRKQjjtd22yizSepI4o`;
export var dice_side__back = `XYS9IllcnL6HN6_K_bOr`;
export var dice_side__right = `XAq3c1qmOTCB4BPa7OQO`;
export var dice_side__left = `V7M8MRUdejBl_ih4kWpg`;
export var dice_side__top = `PcYOCiMX3XsTpvTNs4Og`;
export var dice_side__bottom = `QHYmVYyEzrE1YGPVRIVO`;
export var dice_cover__x = `eEHECNdxyfNetbb2uxhz`;
export var dice_cover__z = `oDuusbeGcEyF9Gaw8UX2`;
export var dice_inner__front = `jB0r1GA_SxACwmxz54e6`;
export var dice_inner__back = `Wgnj2s7ahfzptk3gpxBQ`;
export var dice_inner__right = `HsXdGzSF73NNJcFOkOpN`;
export var dice_inner__left = `OvE3xjWwh3qC_pGkf3qF`;
export var dice_inner__top = `oAgVfLZXk0IR7pPbplDD`;
export var dice_inner__bottom = `fM6UhbbuAduiYXqauaOe`;
export var dice_dot = `k34ylA69xvAnTJze51RY`;
export var dice_dot__center = `EHQX7Pc5tKXz0Qv7yQqA`;
export var dice_dot__top = `T0E1Zj7uBztCXs7tDMKN`;
export var dice_dot__left = `YdUNYih5T3ONxmbtszgR`;
export var dice_dot__right = `zHBOyu8Lsc9ZpXWUEiDj`;
export var dice_dot__bottom = `DH3FbQg1SP0Jygl9GKwo`;
export var dice__animateEnterActive = `ULkUBsWsjl2ipabpjTGK`;
export var dice__animateLeaveActive = `y7aaWWVEOJ6rLo86sXw8`;
export var dice__animateEnter = `nCq3rlXBk5QwP7pAeOAN`;
export var dice__animateLeaveTo = `QCC0Eh2jUB1wXKtIdrkW`;
export default ___CSS_LOADER_EXPORT___;
